<template>
    <div class="legal-landing">
        <h1>{{trans.get("legal.returnspolicy.title")}}</h1>
            <p>{{trans.get("legal.returnspolicy.text1")}}</p>
            <p>{{trans.get("legal.returnspolicy.text2")}}</p>
            <p>{{trans.get("legal.returnspolicy.text3")}}</p>
            <p>{{trans.get("legal.returnspolicy.text4")}}</p>
    </div>
</template>

<script>
export default {};
</script>
